import React, { useEffect, useMemo, useRef, useState } from "react";
import { Toast } from "primereact/toast";
import { Button, Col, Container, Modal, Row } from "react-bootstrap";
import DropdownPicker from "../../components/pickers/dropdownPicker";
import { Checkbox } from "primereact/checkbox";
import { InputNumber } from "primereact/inputnumber";
import COLORS from "../../constants/color";
import DataTableComponent from "../../components/dataTables/dataTable";
import { ConfirmDialog } from "primereact/confirmdialog";
import 'primeicons/primeicons.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencil } from "@fortawesome/pro-solid-svg-icons";
import CustomListModal from "./saveCustomListModal";
import { PersonalScoringApi, Configuration } from "../../services/personalScoring";
import { debounce, findIndex } from 'lodash';
import { useSelector } from "react-redux";
import { faXmark } from "@fortawesome/pro-regular-svg-icons";
import BlinkerBar from "../../components/blinker";
import { CSSTransition } from "react-transition-group";
import ListBar from "./components/listBarSymbolSorting";
import "./symbolPersonalSort.scss";
import { Configuration as IndexServiceApiConfiguration, IndexServiceApi, PageName } from "../../services/actionHub";
import { DashboardServiceApi as WatchlistDashboardServiceApi } from "../../services/watchlist/api";
import { Configuration as WatchlistConfiguration } from "../../services/watchlist/configuration";
import { APIControl } from "../../helpers/APIControl";
import Spinner from "../../components/spinner";
import { useTranslation } from "react-i18next";
import { useHitTracking } from "../../context/hit-tracking-context";

const parseValue = (value) =>
    value === undefined || value === null || value === '' ? 0 : Number(value);

const SymbolPersonalSort = () => {
    const { trackInteraction } = useHitTracking();
    const api = useMemo(() => new PersonalScoringApi(new Configuration({
        basePath: process.env.REACT_APP_PERSONALSCORING_API_BASE_PATH,
    })), []);
    const actionHubIndexApi = useMemo(() => new IndexServiceApi(
        new IndexServiceApiConfiguration({ basePath: process.env.REACT_APP_ACTION_HUB_API_BASE_PATH }),
        undefined,
        APIControl(process.env.REACT_APP_ACTION_HUB_API_BASE_PATH)
    ), []);
    const watchlistServiceApi = useMemo(() => new WatchlistDashboardServiceApi(
        new WatchlistConfiguration({ basePath: process.env.REACT_APP_WATCHLIST_API_BASE_PATH }),
        undefined,
        APIControl(process.env.REACT_APP_WATCHLIST_API_BASE_PATH)
    ), []);
    const { t, i18n } = useTranslation();
    const toast = useRef(null);
    const listBarRef = useRef();
    const [indexList, setIndexList] = useState([]);
    const [systemFilterList, setSystemFilterList] = useState([]);
    const [selectedSystemFilter, setSelectedSystemFilter] = useState(null);

    const [selectedWatchlist, setSelectedWatchlist] = useState();
    const [scoreFields, setScoreFields] = useState(null);

    const [ingredients, setIngredients] = useState([]);
    const [totalScore, setTotalScore] = useState(null);

    const [tableData, setTableData] = useState([]);
    const [visibleAlert, setVisibleAlert] = useState(false);
    const [alertMessage, setAlertMessage] = useState("");
    const token = useSelector((state) => state.auth?.token);

    const [saveAsInputValue, setSaveAsInputValue] = useState('');
    const [saveAsModalShow, setSaveAsModalShow] = useState(false);

    const [selectedIndex, setSelectedIndex] = useState(null);
    const [watchlistsData, setWatchlistsData] = useState(null);
    const [emptyTableMessage, setEmptyTableMessage] = useState(t('personalSorting.adjustFilter'))
    const [isLoadingTable, setIsLoadingTable] = useState(true);
    const excelHeaderMap = useMemo(() => {
        const lang = (i18n.language || "").toLowerCase();
        if (lang.startsWith("en")) {
            return { code: "Security Code", name: "Security Name", score: "Score" };
        }
        return { code: "Hisse Kodu", name: "Hisse Adı", score: "Puan" };
    }, [i18n.language]);
    const [isSaveDisabled, setIsSaveDisabled] = useState(true);
    const [isApplyDisabled, setIsApplyDisabled] = useState(true);
    const [selectedCustomList, setSelectedCustomList] = useState(null);
    const scoreFieldsOptionsRef = useRef(null);
    const savedScrollPosition = useRef(0);
    const saveAsModalNodeRef = useRef(null);
    const skipNextApplyRef = useRef(false);
    const skipSystemFilterEffectRef = useRef(false);
    const scoreFieldsInitializedRef = useRef(false);

    const columnsData = useMemo(() => [
        { id: 1, field: 'searchableHeader', displayName: t('tableHeader.securityCode'), header: t('tableHeader.securityCode'), filterField: "code", isFrozen: false, format: "code-f-t", isVisible: true, align: 'left', width: '2%', paddingRight: '0px' },
        { id: 4, field: "name", displayName: t('tableHeader.securityName'), header: t('tableHeader.securityName'), isVisible: true, align: "left", width: '50%' },
        { id: 5, field: "score", displayName: t('tableHeader.score'), header: t('tableHeader.score') + " (Maks=600) ", isVisible: true, align: "center" }
    ], [t]);

    useEffect(() => {
        getScoreFields();
        getWatchlist();
    }, []);

    useEffect(() => {
        if (totalScore === 100 && selectedCustomList) {
            setIsSaveDisabled(false);
            setIsApplyDisabled(false);
        } else {
            setIsSaveDisabled(!selectedCustomList); // Eğer liste seçili değilse kaydet butonu devre dışı
            setIsApplyDisabled(totalScore !== 100); // Eğer skor 100 değilse uygula butonu devre dışı
        }
    }, [totalScore, selectedCustomList]);


    useEffect(() => {
        if (scoreFields) {
            if (!scoreFieldsInitializedRef.current) {
                scoreFieldsInitializedRef.current = true;
                getSystemFilters();
            }
        }
    }, [scoreFields]);

    useEffect(() => {
        if (skipSystemFilterEffectRef.current) {
            skipSystemFilterEffectRef.current = false;
            return;
        }
        if (selectedSystemFilter && totalScore != null) {
            let SelectedScoreFields = selectedSystemFilter.scoreFields;

            console.log("SelectedScoreFields: ", SelectedScoreFields);
            const isProd = false; // process.env.REACT_APP_IS_PROD === 'true';
            if (isProd) {
                SelectedScoreFields = SelectedScoreFields.filter(item => !item.code.includes('Teknik_Analiz'));
            }

            let scoreFields_ = SelectedScoreFields.map((item) => {
                let itt = scoreFields.find((x) => x.code === item.code);
                return {
                    code: itt.code, name: itt.name, value: parseFloat(item.value), checked: true, id: itt.id,
                };
            });



            const totalScore = scoreFields_.reduce((acc, field) => {
                return acc + field.value;
            }, 0);

            scoreFields.forEach((item) => {
                item.checked = scoreFields_.find((x) => x.code === item.code) ? true : false;
            });




            setTotalScore(totalScore);
            setIngredients(scoreFields_);
            getActionHubStockIndexData();

        }
    }, [selectedSystemFilter]);

    useEffect(() => {
        if (skipNextApplyRef.current) {
            skipNextApplyRef.current = false;
            return;
        }
        if (selectedIndex || selectedWatchlist) {
            applyHandler();
        }
    }, [selectedIndex, selectedWatchlist]);



    useEffect(() => {
        if (ingredients)
            setTotalScore(ingredients.reduce((a, b) => a + (b["value"] || 0), 0));
    }, [ingredients]);

    useEffect(() => {
        if (!selectedSystemFilter || indexList.length === 0) {
            const bist100 = indexList.find((x) => x.entityId === "sec.101.411");
            setSelectedIndex(bist100);
            return;
        }

        // Skip when coming from selectedListBarItem (custom list click)
        if (!selectedSystemFilter.nameEng) return;

        const map = {
            Banks: 'sec.101.388',          // XBANK – BIST BANKA
            Industrials: 'sec.101.415'     // XUSIN – BIST SINAİ
        };

        const targetEntityId = map[selectedSystemFilter.nameEng] || null;

        if (targetEntityId) {
            const indexObj = indexList.find((x) => x.entityId === targetEntityId);
            setSelectedIndex(indexObj);
            setSelectedWatchlist(undefined);
        }
    }, [selectedSystemFilter, indexList]);

    const debouncedOnChangeIngredients = useRef(
        debounce((item, value) => {
            const parsedValue = parseValue(value);
            setIngredients(prev =>
                prev.map(ingredient =>
                    ingredient === item ? { ...ingredient, value: parsedValue } : ingredient
                )
            );
        }, 1000)
    ).current;

    useEffect(() => {
        return () => debouncedOnChangeIngredients.cancel();
    }, [debouncedOnChangeIngredients]);

    const getScoreFields = () => {
        api.apiPersonalscoringScorefieldsPost(token).then((res) => {
            if (res.data.length < 0) {
                toast.current.show({ severity: "warn", summary: t('personalSorting.noData'), detail: t('personalSorting.notList'), closable: true, life: 3000, });
                return;
            }

            let scoreFields = res.data.map((item) => ({
                code: item.code, name: item.name, value: 0, checked: false, id: item.id,
            }));

            // Filter out Teknik_Analiz items in production
            const isProd = false; // process.env.REACT_APP_IS_PROD === 'true';
            const filteredCodesList = ['MACD_G', 'CCI_G', 'RSI_G', 'STOCH_G', 'MOM_G', 'DI_G',
                'MA20', 'MA50', 'MA100', 'MA200', 'MOM_H', 'DI_H'];

            if (isProd) {
                scoreFields = scoreFields.filter(item =>
                    !item.code.includes('Teknik_Analiz') &&
                    !filteredCodesList.includes(item.code)
                );
            }

            console.log("scoreFields: ", scoreFields);
            setScoreFields(scoreFields);

        }).catch((err) => {
            console.log(err);
        });
    };

    const onIndexListChange = (e) => {
        if (!e) {
            setSelectedIndex(undefined);

            if (watchlistsData.length > 1)
                setSelectedWatchlist(watchlistsData[0])
            else
                setSelectedIndex(indexList.find((x) => x.entityId === 'sec.101.411'));

            return;
        }

        let index = findIndex(indexList, { entityId: e.entityId });

        if (index !== -1) {
            setSelectedIndex(indexList[index]);
        } else {
            setSelectedIndex(indexList.find((x) => x.entityId === 'sec.101.411'));
        }

        setSelectedWatchlist(undefined);
    };

    const onWatchListChange = (newWatchlist) => {
        if (!newWatchlist || (selectedWatchlist?.id === newWatchlist.id)) {
            setSelectedWatchlist(undefined);
            return;
        }

        const watchlistToSelect = watchlistsData.find(watchlist => watchlist.id === newWatchlist.id) || watchlistsData[0];
        setSelectedIndex(undefined);
        setSelectedWatchlist(watchlistToSelect);
    };

    const selectedListBarItem = (selectedListItem, updateListes) => {
        try {

            if (!updateListes) return;
            if (!selectedListItem) return;
            trackInteraction(`listBar/${selectedListItem.name || selectedListItem.id}`);

            const isProd = false; // process.env.REACT_APP_IS_PROD === 'true';
            let rawScoreFields = selectedListItem.feilds.map((item) => ({ code: item.dataId, value: item.weight }));
            if (isProd) {
                rawScoreFields = rawScoreFields.filter(item => !item.code.includes('Teknik_Analiz'));
            }

            const scoreFields_ = rawScoreFields.map((item) => {
                const itt = scoreFields.find((x) => x.code === item.code);
                if (!itt) return null;
                return { code: itt.code, name: itt.name, value: parseFloat(item.value), checked: true, id: itt.id };
            }).filter(Boolean);

            const newSelectedIndex = selectedListItem.selectedIndexId
                ? indexList.find((x) => x.entityId === selectedListItem.selectedIndexId)
                : undefined;
            const newSelectedWatchlist = !selectedListItem.selectedIndexId
                ? watchlistsData.find((x) => x.id === selectedListItem.selectedWatchlistId)
                : undefined;

            // Skip effects to prevent duplicate API calls
            skipNextApplyRef.current = true;
            skipSystemFilterEffectRef.current = true;

            setSelectedIndex(newSelectedIndex);
            setSelectedWatchlist(newSelectedWatchlist);
            setScoreFields(prev => prev.map(item => ({ ...item, checked: !!scoreFields_.find(x => x.code === item.code) })));
            setIngredients(scoreFields_);
            setTotalScore(scoreFields_.reduce((acc, f) => acc + f.value, 0));
            setSelectedCustomList(selectedListItem);
            setSelectedSystemFilter({ name: selectedListItem.name, scoreFields: rawScoreFields });
            setIsSaveDisabled(false);

            // Single API call with fresh local values
            const reqScoreFields = scoreFields_.map(item => ({ code: item.code, percent: item.value }));
            fetchScoringData(reqScoreFields, newSelectedIndex?.entityId || "", newSelectedWatchlist?.id || "");
        } catch (error) {
            console.log("selectedListBarItem error: ", error);
        }
    };

    const listBarStatus = (status) => {

        if (status === 'empty') {
            setIsSaveDisabled(true);
        } else {
            setIsSaveDisabled(false);
        }
    };

    const onSystemFilterListChange = (value) => {

        console.log("onSystemFilterListChange: ", value);
        if (value) trackInteraction(`systemFilter/${value.name || value.id}`);
        setSelectedSystemFilter(value);
        listBarRef.current.deSelect();
        setIsSaveDisabled(true);
    };

    const onChangeIngredients = (item, e) => {
        // Scroll pozisyonunu kaydet
        if (scoreFieldsOptionsRef.current) {
            savedScrollPosition.current = scoreFieldsOptionsRef.current.scrollTop;
        }
        
        debouncedOnChangeIngredients(item, e.value);
    };

    // ingredients değiştiğinde scroll pozisyonunu geri yükle
    useEffect(() => {
        if (scoreFieldsOptionsRef.current && savedScrollPosition.current > 0) {
            // requestAnimationFrame ile daha yumuşak geçiş
            requestAnimationFrame(() => {
                if (scoreFieldsOptionsRef.current) {
                    scoreFieldsOptionsRef.current.scrollTo({
                        top: savedScrollPosition.current,
                        behavior: 'auto' // smooth yerine auto kullanarak daha hızlı ama yumuşak
                    });
                }
            });
        }
    }, [ingredients]);

    const onIngredientsChange = (e) => {
        const index = scoreFields.findIndex((x) => x.code === e.value);
        if (index === -1) return;

        const updatedScoreFields = scoreFields.map((item, i) =>
            i === index ? { ...item, checked: e.checked } : item
        );
        setScoreFields(updatedScoreFields);

        if (e.checked) {
            setIngredients(prev => [...prev, updatedScoreFields[index]]);
        } else {
            setIngredients(prev => prev.filter((x) => x.code !== e.target.value));
        }
    };

    const applyHandler = (initialLoad = false) => {
        if (!initialLoad) trackInteraction('button/apply');
        let isProd = process.env.REACT_APP_IS_PROD === 'true';
        // isProd = true;
        setIsLoadingTable(true);
        setTableData([])
        if (!initialLoad && totalScore !== 100) {
            if (!isProd) {
                setAlertMessage(t('personalSorting.totalWeightError'));
                setVisibleAlert(true);
            }
            setIsLoadingTable(false);
            return;
        }


        let reqScoreFields = ingredients.map((item) => ({ code: item.code, percent: item.value }));

        let selectedWatchlistId = selectedWatchlist?.id || "";
        let selectedIndexId = selectedIndex?.entityId || "";

        if (!selectedWatchlistId && !selectedIndexId) {
            toast.current.show({ severity: "error", summary: t('error'), detail: t('personalSorting.selectedInfo'), life: 3000 });
            setIsLoadingTable(false);
            return;
        }

        fetchScoringData(reqScoreFields, selectedIndexId, selectedWatchlistId);
    };

    const fetchScoringData = (reqScoreFields, indexId, watchlistId) => {
        setIsLoadingTable(true);
        setTableData([]);
        api.apiPersonalscoringScoringdataPost(token, { indexEntityId: indexId, watchlistId: watchlistId, scoreFields: reqScoreFields }).then((res) => {
            if (res.data.data.length == 0) {
                setEmptyTableMessage(' ');
                setTableData([]);
                return;
            }
            setTableData(res.data.data);
        }).catch((err) => {
            console.log(err);
        }).finally(() => {
            setIsLoadingTable(false);
        });
    };

    const handleEditRenameChange = (e) => {
        setSaveAsInputValue(e.target.value);
    };

    const getActionHubStockIndexData = () => {
        actionHubIndexApi.actionhubCustomindexesGet(token, PageName.PersonelScoring).then((res) => {
            let data = res.data.indexes;

            if (data.length === 0) {
                toast.current.show({ severity: "error", summary: t('error'), detail: t('personalSorting.notComeingIndex'), life: 3000 });
                return;
            }

            const indexListData = data.map((res) => ({
                name: res['name'].trTr,
                nameEnUs: res['name'].enUs,
                code: res.code,
                entityId: res.entityId,
            }));
            // console.log(data);
            setIndexList(indexListData);

            // let defaultIndex = indexListData.find((x) => x.entityId === 'sec.101.411'); // BIST 100
            // setSelectedIndex(defaultIndex);
        });
    };

    const getWatchlist = () => {
        const culture = "tr-TR";
        watchlistServiceApi.watchlistListGet(token, culture).then((res) => {
            const mappedWatchlistData = res.data.items
                .filter(item => item.id.indexOf('predefined') === -1)
                .map(item => ({
                    name: item.name,
                    id: item.id,
                    count: "-"
                }));

            setWatchlistsData(mappedWatchlistData);
            setSelectedWatchlist(undefined);
        }).catch((err) => {
            console.log(err);
        });
    };

    const getSystemFilters = () => {
        api.apiPersonalscoringSystemfiltersPost(token).then((res) => {
            console.log("apiPersonalscoringSystemfiltersPost: ", res.data);
            if (!res.data.error) {
                setSystemFilterList(res.data);
                setSelectedSystemFilter(res.data[0]);
            } else {
                toast.current.show({ severity: "error", summary: t('error'), detail: t('personalSorting.systemFilterNotComing'), life: 3000 });
            }
        }).catch((err) => {
            toast.current.show({ severity: "error", summary: t('error'), detail: t('personalSorting.systemFilterNotComing'), life: 3000 });
            console.log(err);
        });
    };

    const saveAs = () => {
        let usedFields = ingredients.map((item) => ({
            dataId: item.code, weight: item.value,
        }));

        let selectedIndexId = selectedIndex?.entityId || "";
        let selectedWatchlistId = selectedWatchlist?.id || "";

        if (!selectedIndexId && !selectedWatchlistId) {
            toast.current.show({ severity: "error", summary: t('error'), detail: t('personalSorting.selectedInfo'), life: 3000 });
            return;
        }

        const customListEntity = {
            selectedIndexId: selectedIndexId,
            selectedWatchlistId: selectedWatchlistId,
            listName: saveAsInputValue,
            feilds: usedFields,
            isIndustrial: selectedSystemFilter.nameEng === "Industrials" ? true : false
            // isIndustrial: null

        };


        saveAsCustomList(customListEntity);
    };

    const saveAsCustomList = (customListEntity) => {
        api.apiPersonalscoringSaveaspagecustomlistPost(token, customListEntity).then((res) => {
            if (res.data.status === "OK") {
                toast.current.show({ severity: "success", summary: t('successful'), detail: t('listSaved'), life: 3000 });
                setSaveAsModalShow(false);
                setSaveAsInputValue("");

                listBarRef.current.updateList(customListEntity.listName);
            } else {
                toast.current.show({ severity: "error", summary: t('error'), detail: res.data.error || t('faildToSavList'), life: 3000 });
            }
        }).catch((err) => {
            console.log(err);
            toast.current.show({ severity: "error", summary: t('error'), detail: t('faildToSavList') + " : " + err, closable: true, life: 3000 });
        });
    };

    const updateList = () => {
        if (isSaveDisabled) return;
        trackInteraction('button/save');

        let usedFields = ingredients.map((item) => ({
            dataId: item.code, weight: item.value,
        }));

        let selectedIndexId = selectedIndex?.entityId || "";
        let selectedWatchlistId = selectedWatchlist?.id || "";

        if (!selectedIndexId && !selectedWatchlistId) {
            toast.current.show({ severity: "error", summary: t('error'), detail: t('personalSorting.selectedInfo'), life: 3000 });
            return;
        }

        let updateObj = {
            "id": selectedCustomList.id,
            "selectedIndexId": selectedIndexId,
            "selectedWatchlistId": selectedWatchlistId,
            "feilds": usedFields
        };

        api.apiPersonalscoringUpdatepagecustomlistPost(token, updateObj).then((res) => {
            if (res.data.status === "OK") {
                toast.current.show({ severity: "success", summary: t('successful'), detail: t('listUpdate'), life: 3000 });
                listBarRef.current.updateList();
            } else {
                toast.current.show({ severity: "error", summary: t('error'), detail: t('listNotUpdate'), life: 3000 });
            }
        }).catch((err) => {
            console.log(err);
            toast.current.show({ severity: "error", summary: t('error'), detail: t('listNotUpdate') + " :" + err, closable: true, life: 3000 });
        });
    };

    return (
        <div className="symbol-personal-sort-screen">
            <Toast ref={toast} position="bottom-right" />
            <ConfirmDialog
                visible={visibleAlert}
                onHide={() => setVisibleAlert(false)}
                message={alertMessage}
                header="Uyarı"
                icon="pi pi-exclamation-triangle"
                acceptLabel="Tamam"
                rejectLabel=" "
            />

            {/* Custom List Buttons */}
            <div className="m-b-25 d-flex flex-wrap">
                <ListBar ref={listBarRef} selectedListBarItem={selectedListBarItem} listStatus={listBarStatus} />
            </div>

            {/* Custom List Buttons */}

            {/* Dropdown Items */}
            <Container className="m-t-20 p-0 transition">
                <Row className="">
                    <Col
                        lg="3"
                        className="dropdown-col-1 combo-between-text m-t-auto m-b-auto"
                    >
                        <label className="roboto-bold-16 combo-between-text m-t-auto m-b-auto color-text transition">
                            {t('personalSorting.toPerformYourAnalysis')}
                        </label>
                    </Col>
                    <Col lg="3" className="dropdown-col-2">
                        <DropdownPicker listData={indexList} selectedListItem={selectedIndex} onListItemChange={onIndexListChange} icon={true}
                            placeholder={t('personalSorting.selectIndex')} showClear={true}
                        />
                    </Col>
                    <Col
                        lg="1"
                        className="text-col combo-between-text-2 p-0 m-t-auto m-b-auto"
                    >
                        <label className="text roboto-regular-16 p-0 combo-between-text-2 color-text transition">
                            {t('or')}
                        </label>
                    </Col>
                    <Col lg="3" className="dropdown-col-2">
                        <DropdownPicker className='' listData={watchlistsData} selectedListItem={selectedWatchlist}
                            onListItemChange={onWatchListChange} placeholder={t('personalSorting.selectWatchList')} icon={true} showClear={true} />
                    </Col>
                    <Col
                        lg="1"
                        className="text-col p-0 combo-between-text-3 m-t-auto m-b-auto combo-between-text"
                    >
                        <label className="text roboto-bold-16 p-0 combo-between-text-3 color-text transition">
                            {t('personalSorting.choose')}
                        </label>
                    </Col>
                </Row>
            </Container>

            {/* Dropdown Items */}

            {/* SIDE BOX &  TABLE */}
            <Container className="side-box-container m-t-20">
                <Row>
                    {/* SIDE BOX */}
                    <Col lg="3" className="p-l-0 side-box-col">
                        <div className="side-box">
                            <DropdownPicker
                                className="filter-list-dropdown"
                                listData={systemFilterList}
                                optionLabel="name"
                                selectedListItem={selectedSystemFilter}
                                onListItemChange={onSystemFilterListChange}
                                icon={true}
                                placeholder={t("personalSorting.selectReadyFilter")}
                                showClear={true}
                            />

                            <div className="score-fields p-l-15">
                                {scoreFields && scoreFields.map((item, index) => (
                                    <div
                                        className="score-fields-items flex flex-wrap justify-content-left ml-1 p-t-10 p-b-10"
                                        key={item.code}
                                    >
                                        <div className="flex align-items-center">
                                            <Checkbox
                                                inputId={item.code}
                                                name={item.name}
                                                value={item.code}
                                                onChange={onIngredientsChange}
                                                checked={item.checked}
                                            />
                                            <label
                                                htmlFor={item.code}
                                                className="ml-3 color-text roboto-medium-14"
                                            >
                                                {item.name}
                                            </label>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="weighting-div">
                                <label className="weighting-text roboto-medium-14 color-text">
                                    {t('personalSorting.weighting')} (%)
                                </label>
                            </div>
                            <div className="score-fields-options" ref={scoreFieldsOptionsRef}>
                                {ingredients.length <= 0 && (
                                    <label className="info-text roboto-medium-14 color-text">
                                        {t('personalSorting.makeYourChoiceAbove')}
                                    </label>
                                )}

                                {ingredients.map((item, index) => (
                                    <div className="score-div" key={item.id || Math.random()}>
                                        <div className="item">
                                            <label
                                                className="roboto-medium-14 color-text text-align-left item-text"
                                            >
                                                {item.name}
                                            </label>
                                        </div>

                                        <div className="item">
                                            <InputNumber
                                                id="score-input"
                                                inputStyle={{ width: 75 }}
                                                suffix="  %"
                                                className="score-input"
                                                value={ingredients[index].value}
                                                onChange={(e) => onChangeIngredients(item, e)}
                                            />
                                        </div>
                                    </div>
                                ))}
                            </div>

                            {/* Footer */}
                            <Row className="buttons-footer">
                                <Row>
                                    <Col className="text-align-right">
                                        <label className="roboto-bold-16 color-text">
                                            {t('personalSorting.total')}:
                                            <span
                                                className="p-l-15"
                                                style={{
                                                    color: totalScore != 100 ? COLORS.redTextColor : COLORS.greenTextColor,
                                                }}
                                            >
                                                {totalScore} %
                                            </span>
                                        </label>
                                    </Col>
                                </Row>
                                <div className="green-bg">
                                    <div className="action-buttons">
                                        <Button
                                            className="button save roboto-medium-14"
                                            onClick={() => { trackInteraction('button/saveAs'); setSaveAsModalShow(true); }}
                                            style={{ width: '45%' }}
                                        >
                                            {t('saveAs')}
                                        </Button>
                                        <Button
                                            disabled={isSaveDisabled}
                                            className="button save roboto-medium-14"
                                            onClick={() => updateList()}
                                            style={{ width: '30%' }}
                                        >
                                            {t('save')}
                                        </Button>
                                        <Button
                                            disabled={isApplyDisabled}
                                            className="button apply roboto-medium-14"
                                            onClick={() => applyHandler()}
                                            style={{ width: '25%' }}
                                        >
                                            {t('apply')}
                                        </Button>
                                    </div>
                                </div>
                            </Row>

                                <Modal dialogClassName="modal-edit-list" show={saveAsModalShow}
                                    aria-labelledby="contained-edit-modal-title-vcenter" animation={true} backdrop="static"
                                    keyboard={false} centered>
                                    <Modal.Header>
                                        <Modal.Title id="contained-modal-title-vcenter">
                                            <div className="modal-header-wrap">
                                                <h6 className="m-0">Farklı Kaydet</h6>
                                                <div
                                                    className="modal-header-close"
                                                    onClick={() => {
                                                        setSaveAsModalShow(false);
                                                        setSaveAsInputValue("");
                                                    }}
                                                >
                                                    <FontAwesomeIcon icon={faXmark} />
                                                </div>
                                            </div>
                                        </Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>
                                        <Row>
                                            <Col>
                                                <div className="form-group">
                                                    <input data-testid="listName-input" type="text" value={saveAsInputValue}
                                                        onChange={handleEditRenameChange}
                                                        onKeyDown={(e) => e.key === 'Enter' && saveAs()}
                                                        className="form-control listName-input input" id="listName-input"
                                                        placeholder={t('listName')} />
                                                </div>
                                            </Col>
                                        </Row>
                                        <Button onClick={saveAs} className="modal-save-btn save-button">
                                            {t('save')}
                                        </Button>
                                    </Modal.Body>
                                </Modal>
                            {/* Footer */}
                        </div>
                    </Col>
                    {/* SIDE BOX */}

                    {/* TABLE */}
                    <Col lg="9" className="data-table-col">
                        {isLoadingTable && <Spinner height="600px" />}
                        {!isLoadingTable &&

                            <DataTableComponent
                                columnsProp={columnsData}
                                dataProp={tableData}
                                columnsSelect={false}
                                search={false}
                                scrollHeight={"740px"}
                                emptyMessage={emptyTableMessage}
                                excelExport={true}
                                excelExportName={"Kişisel Sıralama"}
                                excelExportFields={['code', 'name', 'score']}
                                excelHeaderMap={excelHeaderMap}
                            />
                        }
                    </Col>
                    {/* TABLE */}
                </Row>
            </Container>
            {/* SIDE BOX &  TABLE */}
        </div>
    );
};

export default SymbolPersonalSort;
